import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IFermenter } from 'app/models/fermenter';
import { AlertController, IonicModule } from '@ionic/angular';

import * as fromBeverage from 'app/state/beverage';
import * as fromBar from 'app/state/bar';
import * as fromUser from 'app/state/user';
import * as fromUnits from 'app/state/units';
import * as fromLocations from 'app/state/location';
import * as fromFermenter from 'app/state/fermenter';
import * as fromExternalApiSettings from 'app/state/external-api-settings/reducer';

import { Store } from '@ngrx/store';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { FormComponent } from './form/form.component';

@Component({
  selector: 'app-fermenter-detail',
  templateUrl: './fermenter-detail.page.html',
  styleUrls: ['./fermenter-detail.page.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, IonicModule, RouterModule, FormComponent]
})
export class FermenterDetailPage {

  item = this.store.selectSignal(fromFermenter.getFermenterWithUnitsFromParams);
  barId = this.store.selectSignal(fromUser.selectBarId);
  userId = this.store.selectSignal(fromUser.selectUserId);
  bar = this.store.selectSignal(fromBar.selectBar);
  units = this.store.selectSignal(fromUnits.getUnits);
  beverages = this.store.selectSignal(fromBeverage.selectAllEntities);
  locations = this.store.selectSignal(fromLocations.selectAllItems);
  /** Undefined until the bar has Brewfather set up — hides the section in the form. */
  brewfather = this.store.selectSignal(fromExternalApiSettings.selectBrewfather);

  constructor(
    private store: Store,
    private router: Router,
    public alertController: AlertController,
  ) { }

  softUpdateFermenter(event: any) {
    this.store.dispatch(fromFermenter.softUpdate({ id: event.id, data: event.data, uid: event.uid }));
  }

  async confirmDelete(item: IFermenter) {
    const alert = await this.alertController.create({
      header: 'Confirm!',
      message: 'Are you sure you want to delete?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Okay',
          handler: () => {
            this.delete(item);
          }
        }
      ]
    });

    await alert.present();
  }

  private delete(item: IFermenter) {
    if (item.id) {
      this.store.dispatch(fromFermenter.deleteItem({ id: item.id }));
      this.router.navigate(['inventory/fermenter']);
    }
  }
}
